/* eslint-disable max-len */
import PropTypes from "prop-types";
import controllers from "./controllers";
import { useDialog } from "../context/messaging-layer";
import env from "../utils/env";
import { isFieldsValid } from "../utils/field-validation";

/**
 * Takes data from [TdFlowApp]{@link TdFlowApp} and creates an instance of the specified Controller of the screen.
 * If screen.osController is not specified, Controller defaults to BaseViewController.
 * Then invokes Controller.execute(), which renders the screen component
 * @function ScreenBuilder
 * @param {object} props Props passed to ScreenBuilder from [TdFlowApp]{@link TdFlowApp}
 * @param {object} props.screen Contains screen content and settings to be rendered
 * @param {object} props.appData Contains data on flow and screen,
 * as well as methods (i.e. screen data, history, validators)
 * @param {object} props.components All default theme components from [Default Themes]{@link module:theme/default}
 * @param {bool} props.isRoot TODO -- clarify usage
 * @param {React.Component} props.TdFlowApp TODO -- clarify usage; likely outdated
 * @returns {React.Component} Calls the [execute]{@link BaseViewController#execute} method on screen's
 * specified Controller, which renders the screen component
 */

// clarify usage of TdFlowApp; likely outdated
function ScreenBuilder({ screen, appData, components, isRoot, TdFlowApp }) {
  // console.log("📝 Building Screen: ", screen.name)
  // console.log("Screen Controller: ", screen?.osController?.iOs);
  // console.log("Screen Data: ", screen);
  const dialog = useDialog();
  const useBrowserNavigation = env("BROWSER_NAVIGATION_ENABLED");

  let Controller =
    controllers[screen?.osController?.websdk] ||
    controllers[screen?.osController?.iOS] ||
    controllers.BaseViewController;

  // console.log("✅ Controller found: ", Controller);
  return new Controller({
    screen,
    appData,
    components,
    isRoot,
    dialog,
    useBrowserNavigation,
    isFieldsValid,
    TdFlowApp
  }).execute();
}

ScreenBuilder.propTypes = {
  screen: PropTypes.objectOf(PropTypes.any),
  appData: PropTypes.objectOf(PropTypes.any),
  components: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.func,
      PropTypes.objectOf(PropTypes.any)
    ])
  ),
  isRoot: PropTypes.bool.isRequired,
  TdFlowApp: PropTypes.objectOf(PropTypes.object)
};

export default ScreenBuilder;
